module.exports = __webpack_public_path__ + "static/media/Vault Office.747bdc96.png";